import { render } from "./Discipline.vue?vue&type=template&id=1c4b758c&scoped=true&ts=true"
import script from "./Discipline.ts?vue&type=script&lang=ts&external"
export * from "./Discipline.ts?vue&type=script&lang=ts&external"

import "./Discipline.scss?vue&type=style&index=0&id=1c4b758c&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4b758c"]])

export default __exports__